import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { useKpiVariableActions } from 'redux/actions/KpiVariables'

import {
  selectShouldFetch,
  selectKpiVariables
} from 'redux/selectors/KpiVariables'

/**
 * Hook for all kpi variables
 * @returns [variables, loading]
 */
export const useKpiVariables = () => {
  return useSelector(selectKpiVariables)
}

/**
 * Hook to check if variables needs fetching
 * @returns fetched
 */
export const useShouldFetchKpiVariables = () => {
  return useSelector(selectShouldFetch)
}

/**
 * Hook for all kpi variables, fetched when the store has none yet
 * @returns [variables, loading]
 */
export const useFetchedKpiVariables = () => {
  const { tryGetAllKpiVariables } = useKpiVariableActions()

  const shouldFetch = useShouldFetchKpiVariables()

  useEffect(() => {
    if (shouldFetch) {
      tryGetAllKpiVariables()
    }
  }, [shouldFetch, tryGetAllKpiVariables])

  return useKpiVariables()
}
